<template>
    <HomeLayoutBack :hideMobile="false" customClass="max-w-full">
        <div class="max-full-hd">
            <BackButtonDesktop @clickBack="clickBack()" customClass="lg:hidden"></BackButtonDesktop>
            <div class="font-bold text-18 text-a-brown-502314 text-center py-4">
                {{ title }}
            </div>
            <div class="text-14 text-a-brown-502314 text-center pb-4" v-show="text != ''">
                {{ text }}
            </div>
            <DashboardSlider class="container-custom mx-auto" :apiConfig="dashboardInfoConfig"></DashboardSlider>
            <DownloadApp></DownloadApp>
        </div>
    </HomeLayoutBack>
</template>

<script>

import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
//helper
import Locale from "@/helper/locale/Locale.js";
//component
import HomeLayoutBack from '@/components/Layout/Page/HomeLayoutBack.vue';
import BackButtonDesktop from '@/components/Button/BackButtonDesktop.vue';
import DashboardSlider from "../component/DashboardSlider.vue";
import DownloadApp from '@/module/Home/component/DownloadApp.vue';
//config
import ConfigManager from '@/config/ConfigManager.js';

export default {
    name: 'Info',
    components: {
        HomeLayoutBack,
        BackButtonDesktop,
        DashboardSlider,
        DownloadApp,
    },
    computed: {

    },
    setup() {

        const route = useRoute()
        let lbl = Locale.getLbl();

        var infoPage = route.params.infoPage;
        let title = ref('');
        let text = ref('');
        let dashboardInfoConfig = ref('')

        if (infoPage == 'freshtaste') {
            dashboardInfoConfig.value = ConfigManager.getDashboardFreshTaste()
            title.value =  lbl.info.freshtaste.title

        } else if (infoPage == 'madetoorder') {
            dashboardInfoConfig.value = ConfigManager.getDashboardMadeToOrder()
            title.value = lbl.info.madetoorder.title
            text.value = lbl.info.madetoorder.text

        } else if (infoPage == 'promotions') {
            dashboardInfoConfig.value = ConfigManager.getDashboardPromotions()
            title.value = lbl.info.promotions.title
        } else if (infoPage == 'catering') {
            dashboardInfoConfig.value = ConfigManager.getDashboardCatering()
            title.value =  lbl.info.catering.title

        }
        onMounted(() => {
            window.scrollTo(0,0)
        })
        return{
            lbl,
            infoPage,
            title,
            text,
            dashboardInfoConfig,
        }

    }
};
</script>
<style lang="scss" scoped>
@import '@/style/base/display.scss';

.screen-height {
    min-height: none;
}
</style>

